import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import parse from 'html-react-parser';
import Sidebar from './sidebar';
import ScrollAnimation from 'react-animate-on-scroll';

class Rules extends Component {

    render() {

        let publicUrl = process.env.PUBLIC_URL+'/'

    return  <div className="course-single-area pd-top-120 pd-bottom-110">
		  <div className="container">
		    <div className="row">
		      <div className="col-lg-8 ">
		        <div className="event-detaila-inner">
                  
					<ScrollAnimation animateIn="fadeInRight">
					<div className='blog-details-page-content'>
						<blockquote>
							<ul>
                                <li>Punctuality and regularity in attendance is essential. </li>
                                <li>Students must come to school in neat attire and polished shoes prescribed for their course of study. The hair should be trimmed and combed neatly.</li>
                                <li>Students are not allowed to use mobile phones inside the classrooms / campus.</li>
                                <li>Utmost care should be taken while handing school property and school belongings.</li>
                                <li>Care should be taken towards keeping the campus clean.</li>
                                <li>Students must speak in decent language all the time. He / she must ensure that the speech is courteous and polite.</li>
                                <li>Every student is expected to carry necessary study materials according to their course of study.</li>
                                <li>Any communication received from the institution should be acknowledged by the parent / guardian.</li>
                                <li>A student must extend due courtesy and respect to all staff members.</li>
                                <li>Additional to the above, students are expected to adhere to the norms suggested for their course of study.</li>
                            </ul>
						</blockquote>
					</div>
					</ScrollAnimation>		
				  </div>
		      </div>
			  <Sidebar />
		    </div>
		  </div>
		</div>

        }
}

export default Rules